const initialState = {
  email: "",
  showError: false,
  id: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_RESET_PASSWORD":
      return { ...state, email: action.payload };

    case "RESET_PWD_ERROR":
      return { ...state, showError: action.payload };

    case "SET_PWD_ID":
      return { ...state, id: action.payload };

    case "RESET_PWD":
      return { ...state, ...initialState };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/resetPassword.reducer.js